import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth.tsx';
import { routes } from '@/navigation/routes.tsx';
import { useProfileStore } from '@/store/useProfileStore.ts';
import ErrorWrapper from '@/components/common/ErrorWrapper/ErrorWrapper.tsx';
import { helpers } from '@/helpers.ts';
import usePolicy from '@/hooks/usePolicy.ts';

const Protected: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { aboutMe } = useProfileStore();
  const { isOnboarding, isFailedVerification, isDeleted, isBanned } =
    usePolicy();

  if (!isAuthenticated) {
    return <Navigate to={routes.login} />;
  }

  if (isFailedVerification || isOnboarding) {
    return <Navigate to={helpers.checkRegistrationRoute(aboutMe?.profile)} />;
  }

  if (isDeleted) {
    return <Navigate to={routes.deletedProfile} />;
  }

  if (isBanned) {
    return <Navigate to={routes.banned} />;
  }

  return <ErrorWrapper>{children}</ErrorWrapper>;
};

export default Protected;
